import React from 'react';
import JarvisWidget from '../../../components/widgets/JarvisWidget';

export default class DashboardMetrics extends React.Component {
  
  render() {
    const { isLoading, data } = this.props;
    const plannedCount = data.list && data.list.find(
      el => el.name === 'Planned'
    );
    const implementationCount = data.list && data.list.find(
      el => el.name === 'Implementation'
    );
    const activeCount = data.list && data.list.find(
      el => el.name === 'Active'
    );
    const probationCount = data.list && data.list.find(
      el => el.name === 'Probation'
    );
    const inactiveCount = data.list && data.list.find(
      el => el.name === 'Inactive'
    );
    const client = data.list && data.list.find(
      el => el.name === 'ClientEscalations'
    );
    const patient = data.list && data.list.find(
      el => el.name === 'PatientEscalations'
    );
    const location = data.list && data.list.find(
      el => el.name === 'LocationEscalations'
    );
    const dpc = data.list && data.list.find(
      el => el.name === 'DPC'
    );
    const enterprise = data.list && data.list.find(
      el => el.name === 'Enterprise'
    );

    const total = (dpc && dpc.count) + (enterprise && enterprise.count);

    const eligible = data.list && data.list.find(
      el => el.name === 'EligiblePatients'
    );

    const engaged = data.list && data.list.find(
      el => el.name === 'EngagedPatients'
    );

    return (
      <div className="row">
        <div className="col-md-3">
          <JarvisWidget
            togglebutton={false}
            editbutton={false}
            fullscreenbutton={false}
            colorbutton={false}
            deletebutton={false}
          >
            <header>
              <span className="widget-icon">
                <i className="glyphicon glyphicon-stats txt-color-darken" />{' '}
              </span>
              <h2>Health Center Status Metrics</h2>
            </header>
            <div>
              <div className="widget-body">
                {isLoading && <div className="spinner-wrap"><div className="spinner" /></div>}
                <div className="clinics-today-stats">
                  <ul className="list-group">
                    <li className="list-group-item">
                      <span className="label label-info pull-right">
                        {plannedCount && plannedCount.count.toLocaleString()}
                        {!plannedCount && 0}
                      </span>
                      <span className="label label-info">Planned</span>
                    </li>
                    <li className="list-group-item">
                      <span className="label label-info pull-right">
                        {implementationCount && implementationCount.count.toLocaleString()}
                        {!implementationCount && 0}
                        </span>
                      <span className="label label-info">Implementation</span>
                    </li>
                    <li className="list-group-item">
                      <span className="label label-info pull-right">
                        {activeCount && activeCount.count.toLocaleString()}
                        {!activeCount && 0}
                        </span>
                      <span className="label label-info">Active</span>
                    </li>
                    <li className="list-group-item">
                      <span className="label label-info pull-right">
                        {probationCount && probationCount.count.toLocaleString()}
                        {!probationCount && 0}
                        </span>
                      <span className="label label-info">Probation</span>
                    </li>
                    <li className="list-group-item">
                      <span className="label label-info pull-right">
                        {inactiveCount && inactiveCount.count.toLocaleString()}
                        {!inactiveCount && 0}
                        </span>
                      <span className="label label-info">Inactive</span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </JarvisWidget>
        </div>

        <div className="col-md-3">
          <JarvisWidget
            togglebutton={false}
            editbutton={false}
            fullscreenbutton={false}
            colorbutton={false}
            deletebutton={false}
          >
            <header>
              <span className="widget-icon">
                <i className="glyphicon glyphicon-stats txt-color-darken" />{' '}
              </span>
              <h2>Open Escalations Metrics</h2>
            </header>
            <div>
              <div className="widget-body">
                {isLoading && <div className="spinner-wrap"><div className="spinner" /></div>}
                <div className="clinics-today-stats">
                  <ul className="list-group">
                    <li className="list-group-item">
                      <span className="label label-info pull-right">
                        {client && client.count.toLocaleString()}
                        {!client && 0}
                      </span>
                      <span className="label label-info">Client Escalations</span>
                    </li>
                    <li className="list-group-item">
                      <span className="label label-info pull-right">
                        {patient && patient.count.toLocaleString()}
                        {!patient && 0}
                      </span>
                      <span className="label label-info">Patient Escalations</span>
                    </li>
                    <li className="list-group-item">
                      <span className="label label-info pull-right">
                        {location && location.count.toLocaleString()}
                        {!location && 0}
                      </span>
                      <span className="label label-info">Location Escalations</span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </JarvisWidget>
        </div>
        <div className="col-md-3">
          <JarvisWidget
            togglebutton={false}
            editbutton={false}
            fullscreenbutton={false}
            colorbutton={false}
            deletebutton={false}
          >
            <header>
              <span className="widget-icon">
                <i className="glyphicon glyphicon-stats txt-color-darken" />{' '}
              </span>
              <h2>Active Clients Metrics</h2>
            </header>
            <div>
              <div className="widget-body">
                {isLoading && <div className="spinner-wrap"><div className="spinner" /></div>}
                <div className="clinics-today-stats">
                  <ul className="list-group">
                    <li className="list-group-item">
                      <span className="label label-info pull-right">
                        {enterprise && enterprise.count.toLocaleString()}
                        {!enterprise && 0}
                      </span>
                      <span className="label label-info">Enterprise</span>
                    </li>
                    <li className="list-group-item">
                      <span className="label label-info pull-right">
                        {dpc && dpc.count.toLocaleString()}
                        {!dpc && 0}
                      </span>
                      <span className="label label-info">DPC</span>
                    </li>
                    <li className="list-group-item">
                      <span className="label label-info pull-right">
                        {!isNaN(total) && total.toLocaleString()}
                        {isNaN(total) && 0}
                      </span>
                      <span className="label label-info">Total</span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </JarvisWidget>
        </div>

        <div className="col-md-3">
          <JarvisWidget
            togglebutton={false}
            editbutton={false}
            fullscreenbutton={false}
            colorbutton={false}
            deletebutton={false}
          >
            <header>
              <span className="widget-icon">
                <i className="glyphicon glyphicon-stats txt-color-darken" />{' '}
              </span>
              <h2>Active Patients Metrics</h2>
            </header>
            <div>
              <div className="widget-body">
                {isLoading && <div className="spinner-wrap"><div className="spinner" /></div>}
                <div className="clinics-today-stats">
                  <ul className="list-group">
                    <li className="list-group-item">
                      <span className="label label-info pull-right">
                        {eligible && eligible.count.toLocaleString()}
                        {!eligible && 0}
                      </span>
                      <span className="label label-info">Eligible Patients</span>
                    </li>
                    <li className="list-group-item">
                      <span className="label label-info pull-right">
                        {engaged && engaged.count.toLocaleString()}
                        {!engaged && 0}
                      </span>
                      <span className="label label-info">Engaged Patients</span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </JarvisWidget>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/routes/dashboard/components/DashboardMetrics.js